import * as React from 'react';

import { Box, StyleSheet, color, css } from '@coursera/coursera-ui';

import { AutoEnrollmentForm } from 'bundles/internal-enterprise/components/InternalThirdPartyOrganizationPage/AutoEnrollmentForm';
import { TriggerEvent } from 'bundles/internal-enterprise/components/InternalThirdPartyOrganizationPage/constants/AutoEnrollmentConstants';
import Button from 'bundles/internal-ui/components/buttons/Button';
import Modal from 'bundles/internal-ui/components/modal/Modal';

import _t from 'i18n!nls/internal-enterprise';

const styles = StyleSheet.create({
  errorMessage: {
    textAlign: 'center',
    color: color.error,
  },
  buttonWrapper: {
    marginBottom: '20px',
  },
});

type State = {
  targetCourseId: string;
  triggerType: TriggerEvent;
  triggeredByCourseId: string;
};

export type AutoEnrollmentRow = {
  courseId: string;
  enrollIn: string;
  enrollmentTrigger: string;
  id: string;
  targetProgramId: string;
  triggerType: TriggerEvent;
  triggeredByCourse: string;
  triggeredCourseId: string;
};

type Props = {
  row: AutoEnrollmentRow;
  closeModal: () => void;
  programId?: string;
  showModal: boolean;
  handleUpdate: (
    targetProgramId: string,
    targetCourseId: string,
    triggerType: TriggerEvent,
    triggeredByCourseId: string,
    rowId: string
  ) => void;
  error?: string;
};

export class AutoEnrollmentEditTriggerModal extends React.Component<Props, State> {
  state: State = {
    targetCourseId: '',
    triggerType: TriggerEvent.JOIN_PROGRAM,
    triggeredByCourseId: '',
  };

  componentDidMount = () => {
    const { row } = this.props;
    this.setState({
      targetCourseId: row.courseId,
      triggerType: row.triggerType,
      triggeredByCourseId: row.triggeredCourseId,
    });
  };

  updateTrigger = () => {
    const { row, handleUpdate } = this.props;
    const { targetCourseId, triggerType, triggeredByCourseId } = this.state;
    return handleUpdate(row.targetProgramId, targetCourseId, triggerType, triggeredByCourseId, row.id);
  };

  isUpdateDisabled = () => {
    const { targetCourseId, triggeredByCourseId, triggerType } = this.state;
    if (triggerType === TriggerEvent.JOIN_PROGRAM) {
      return !targetCourseId;
    } else {
      return !targetCourseId || !triggeredByCourseId;
    }
  };

  render() {
    const { targetCourseId, triggerType, triggeredByCourseId } = this.state;
    const { closeModal, showModal, error } = this.props;

    return (
      <Modal title={_t('Edit Auto-Enrollment Rule')} open={showModal} onRequestClose={closeModal} showCloseIcon={true}>
        <div>
          <AutoEnrollmentForm
            handleTargetCourseIdInput={(e) => this.setState({ targetCourseId: (e.target as HTMLInputElement).value })}
            targetCourseId={targetCourseId}
            setTriggerType={(trigger) => this.setState({ triggerType: trigger as TriggerEvent })}
            triggerType={triggerType}
            handleTriggeredByCourseInput={(e) =>
              this.setState({ triggeredByCourseId: (e.target as HTMLInputElement).value })
            }
            triggeredByCourseId={triggeredByCourseId}
          />
          {error && (
            <div {...css(styles.errorMessage)}>
              {_t('Unable to update auto enrollment rule!')} {error}
            </div>
          )}
          <Box alignItems="end" justifyContent="end" rootClassName={styles.buttonWrapper}>
            <Button text={_t('Update')} onClick={this.updateTrigger} disabled={this.isUpdateDisabled()} />
          </Box>
        </div>
      </Modal>
    );
  }
}

export default AutoEnrollmentEditTriggerModal;
